import { Controller, useFormContext } from 'react-hook-form';
import { Switch } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import type { IntegrationFormValue } from '../../integrationFormSchema';

export function IntegrationRequestPolicy() {
  return (
    <section className="border-input overflow-hidden rounded-md border">
      <header className="bg-muted/40 border-input border-b px-4 py-3">
        <h2 className="text-sm font-semibold">
          {dashboardT('integrations.sections.requestPolicy')}
        </h2>
      </header>
      <div className="divide-border divide-y">
        <IntegrationInlineSwitch
          name="blockBidsWithoutCat"
          label={dashboardT('integrations.blockNoCat')}
          description={dashboardT('integrations.hints.blockNoCat')}
        />
        <IntegrationInlineSwitch
          name="blockBidsWithoutAdomain"
          label={dashboardT('integrations.blockNoAdomain')}
          description={dashboardT('integrations.hints.blockNoAdomain')}
        />
      </div>
    </section>
  );
}

export function IntegrationInlineSwitch({
  name,
  label,
  description,
}: {
  name:
    | 'blockBidsWithoutCat'
    | 'blockBidsWithoutAdomain'
    | 'multipleImpressionsEnabled'
    | 'duplicateDemandIntegration'
    | 'dupUseDefaultFloor';
  label: string;
  description?: string | undefined;
}) {
  const { control } = useFormContext<IntegrationFormValue>();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <label className="hover:bg-muted/30 flex min-h-11 cursor-pointer items-center justify-between gap-4 px-4 py-2.5 text-sm transition-colors">
          <span className="min-w-0">
            <span className="block">{label}</span>
            {description ? (
              <span className="text-muted-foreground mt-0.5 block text-xs leading-relaxed">
                {description}
              </span>
            ) : null}
          </span>
          <Switch aria-label={label} checked={field.value} onCheckedChange={field.onChange} />
        </label>
      )}
    />
  );
}
